import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { GiftCardTopupDto } from '@up/data';
import { BaseService } from './BaseService.service';
import { ENV_OPTIONS } from "@up/shared/injection-tokens";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class GiftCardTopUpService extends BaseService<GiftCardTopupDto> {

    constructor(@Inject(ENV_OPTIONS) environmentOptions: any,
                httpClient: HttpClient) {
        super(environmentOptions, httpClient);
        this.apiEndPoint = 'gift-card-topup';
        this.title = 'Gift Card Top UP';
    }

    getTopupById(id: string | number): Observable<GiftCardTopupDto> {
        const url = this.getFullUrl() + `/getById/${id}`;

        return this.httpClient
            .get<GiftCardTopupDto>(url)
            .pipe(catchError(this.handleError));
    }
}
